import type { FunctionComponent, ReactNode } from 'react';

import { IconActive } from './IconActive';
import { IconCompleted } from './IconCompleted';
import { IconPending } from './IconPending';

import S from './style.scss';

export type StageStateT = 'ACTIVE' | 'COMPLETED' | 'PENDING';

type PropsT = {
  label: string;
  state: StageStateT;
};

export const Stage: FunctionComponent<PropsT> = ({ label, state }) => {
  let icon: ReactNode;
  let containerClassName: string;

  switch (state) {
    case 'ACTIVE':
      icon = <IconActive />;
      containerClassName = S.current;
      break;
    case 'COMPLETED':
      icon = <IconCompleted />;
      containerClassName = S.completed;
      break;
    case 'PENDING':
      icon = <IconPending />;
      containerClassName = S.pending;
      break;
    default: throw Error('Unexpected case');
  }

  containerClassName += ` ${S.container}`;

  return (
    <div className={containerClassName}>
      {icon}
      <div styleName="label">{label}</div>
    </div>
  );
};
